import * as React from "react";
import * as ReactTransitionGroup from "react-addons-transition-group";

import Layout from "../definitions/Layout";
import Notification from "./Notification";
import ConfigFactory from "../utils/ConfigFactory";
import {NotificationStateList} from "../definitions/Config";

export interface BubbleManagerProps {

    /** Bubbles showing yes / no */
    pause: boolean;

    /** Notification Configs that must be rendered as bubbles */
    notificationStateList: NotificationStateList;

    /** CSS Class */
    className?: string;
}

/**
 * Visual Component for the Bubble Manager
 * Reacts to the API notifications list
 */
export default class BubbleManager extends React.Component<BubbleManagerProps, {}> {

    getStyles() {
        return {
            root: {
                top: "54px",
                left: "16px",
                width: "400px",
                position: "fixed",
                zIndex: diy.editor.getNewTopZIndex(),
                pointerEvents: "none"
            }
        };
    }

    render() {
        let styles = this.getStyles();
        let notificationStateList = this.props.notificationStateList;

        /**
         * The <ReactTransitionGroup> wrapper allow us to add extra behaviours
         * when the component shows, leaves, etc.
         */
        if (!this.props.pause) {
            return (
                <div className={this.props.className} style={styles.root}>
                    {Array.from(notificationStateList)
                        .map(([key, notificationState]) => {

                            if (!notificationState.dismissed && !notificationState.deleted) {
                                let notificationConfig = ConfigFactory.factory(
                                    notificationState
                                );
                                return (
                                    <ReactTransitionGroup key={key}>
                                        <Notification
                                            layout={Layout.Bubble}
                                            config={notificationConfig} />
                                    </ReactTransitionGroup>
                                );
                            }

                            return null;
                        })
                    }
                </div>
            );

        } else {
            return null;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/components/BubbleManager.tsx
 **/